import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Button, Flex, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { loginSourceSelector } from '../../../../core/sourceData/sourceDataSlice.js';
import { useTranslatedSourceOverrideLabel } from '../../../../hooks/useTranslatedLabel.js';
import { trackButtonClick, trackModalView } from '../../../../tracking/index.js';
import { setEmailChangeAlertStatus } from '../../../Login/loginSlice.js';
import { storageKeys } from '../../../../constants/storageKeys.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { ContentHeading } from '../../../../components/common/ContentHeading/index.js';
import { LoginNegativeAlert } from '../../../Login/components/LoginNegativeAlert/index.js';
import { LoginWithEmailForm } from '../../../Login/components/LoginWithEmailForm/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../twoStepLoginRegistrationSlice.js';
import { updateTwoStepActiveState } from '../../twoStepLoginRegistrationSlice.js';
import { TwoStepConsent } from '../../components/TwoStepConsent/index.js';
import { INITIAL_TRACKING_DELAY } from '../../../../constants/tracking.js';
export const TwoStepLogin = () => {
    const { t } = useTranslation();
    const loginSource = useAppSelector(loginSourceSelector);
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const dispatch = useAppDispatch();
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const headerLabel = useSourceOverrideLabel('twoStepLoginRegistration.login.header');
    useEffect(() => {
        const isEmailChangeSuccessful = sessionStorage.getItem(storageKeys.isEmailChangeSuccessful) === 'true';
        if (isEmailChangeSuccessful) {
            dispatch(setEmailChangeAlertStatus(isEmailChangeSuccessful));
        }
        // setTimeout to keep correct tracking events order
        setTimeout(() => dispatch(sendGlobalTrackingThunk(trackModalView, { componentState })), INITIAL_TRACKING_DELAY);
    }, []);
    const onShowAllOptions = (e) => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'showAllOptions',
            componentState,
        }));
        e.preventDefault();
        dispatch(updateTwoStepActiveState('accountIdentifier'));
    };
    return (_jsx(_Fragment, { children: _jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "two-step-login-form", children: [_jsx(ContentHeading, { label: headerLabel }), _jsx(LoginNegativeAlert, {}), _jsx(LoginWithEmailForm, {}), _jsx(Flex, { flxJustify: 'center', children: _jsx(Button, { variant: "link", a11yLabel: "show-social-button", "data-testid": "display-socials-button-link", onClick: (e) => onShowAllOptions(e), sx: {
                            fontSize: 'fontSizeM',
                            fontWeight: 'fontWeightNormal',
                        }, children: t('loginregistration.twoStepLoginRegistration.login.backLink') }) }), _jsx(TwoStepConsent, { label: t('loginregistration.twoStepLoginRegistration.login.legalNote'), variant: "login" })] }) }));
};
//# sourceMappingURL=TwoStepLogin.js.map